var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',[_c('oil-cap',{attrs:{"title":"Счет фактуры","buttons":[
      {
        route: 'coming-invoice',
        name: 'Добавить Счет фактуру'
      }
    ],"items":_vm.invoices}}),_c('v-divider',{staticClass:"my-2"}),_c('oil-table',{attrs:{"keys":[
      {
        text: 'Поставщик',
        value: 'SupplierName'
      },
      {
        text: 'Договор',
        value: 'ContactNumber'
      },
      {
        text: 'Счет фактура',
        value: 'Number'
      },
      {
        text: 'Количество',
        value: 'Amount'
      },
      {
        text: 'Сумма',
        value: 'Total'
      },
      {
        text: 'Статус',
        value: 'Status'
      }
    ],"items":_vm.invoices,"paginate":_vm.count,"rowClick":_vm.handleRowClick},on:{"paginateAction":_vm.paginate}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }